import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { Partida } from 'src/app/shared/models/partida';
import { DetallePartidaComponent } from '../detalle-partida/detalle-partida.component';
import { takeUntil } from 'rxjs/operators';
import { DatePipe, DecimalPipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ActivatedRoute } from '@angular/router';
import { Constanst } from 'src/app/core/constants/constans.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
registerLocaleData(localeEs, 'es');

@Component({
  selector: 'app-partidas',
  templateUrl: './partidas.component.html',
  styleUrls: ['./partidas.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class PartidasComponent implements OnInit {
  id: string
  partidas: Partida[];
  displayedColumns: string[] = ['reference', 'code', 'description', 'unit', 'lowPerformance', 'lineItemGrouping'];
  displayedColumnsMaterial: string[] = ['reference', 'description', 'unit', 'quantity', 'waste', 'price', 'total'];
  displayedColumnsEquipos: string[] = ['reference', 'description', 'quantity', 'waste', 'price', 'total'];
  displayedColumnsManoObras: string[] = ['reference', 'description', 'quantity', 'jornal', 'bono', 'totaljornal', 'totalbono'];

  filterColumForm = new FormGroup({
    filterDetails: new FormControl('0'),
    descriptionFilter: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  filterSearchForm = new FormGroup({
    descriptionSearch: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });

  clickedRows = new Set<Partida>();
  filterNoSelected: boolean = false;
  messageError: string;
  filterDictionary = new Map<string | null, string | null>();
  xpandStatus = false;
  xpandDisabled = true;
  referenciaPartida: string = "(clic en tabla)";
  precioPartida: number = 0.00;
  descripcionPartida: string;

  totalMateriales: number;
  totalEquipos: number;
  totalManoDeObra: number;
  totalBonoManoDeObra: number;
  apuConditionId: number;

  partida: any;

  dataSource = new MatTableDataSource<Partida>;
  dataSourceFilters = new MatTableDataSource<Partida>;
  dataSourceMaterial = new MatTableDataSource<any>;
  dataSourceEquipo = new MatTableDataSource<any>;
  dataSourceManosObra = new MatTableDataSource<any>;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  rendimiento: number;
  porcFinanciamiento: number;
  porcGastosAdministrativos: number;
  porcImpuestoIva: number;
  porcOtrosImpuestos: number;
  porcUtilidadesImprevisto: number;
  porcPrestacionesManoDeObra: number;
  costoUnicoMateriales: number;
  costoUnicoEquipo: number;
  prestManoDeObra: number;
  totalGeneralManoDeObra: number;
  costoUnicoManoDeObra: number;
  costoDirectoSubTotalA: number;
  gastosGeneralesAdmin: number;
  subTotalB: number;
  utilidadesImprevisto: number;
  subTotalC: number;
  financiamiento: number;
  precioUnitarioSinImpuesto: number;
  montoImpuestoIva: number;
  montoOtrosImpuestos: number;
  precioUnitario: number;
  porcIncidenciasMateriales: number;
  porcIncidenciasEquipos: number;
  porcIncidenciasManoDeObra: number;
  totalTrabajadores: number;
  workingHour: number;
  workingHourDay: number;

  totalItemsPage: number;
  dataListPartidas: Partida[];
  disableButtonfilter: boolean = true;
  disableButtonSearch: boolean = false;
  typeAction: string;
  defaultFilterDetails = 'description';
  classFlag: boolean = false;

  constructor(
    public dialogDetallePartida: MatDialog,
    private apiCallService: ApiCallService,
    private activatedRoute: ActivatedRoute,
    private decimalPipe: DecimalPipe,
    private helperClassService: HelperClassService,
  ) { }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.filterColumForm.get('filterDetails')!.setValue(this.defaultFilterDetails);
    this.id = (this.activatedRoute.snapshot.paramMap.get('id') || 'construccion');
    this.getAllLineItem();
    this.cleanFilter();
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      if (this.typeAction == 'filterColum') {
        this.applyFilterDetails();
      } else if (this.typeAction == 'filterSearch') {
        this.applyFilter();
      } else {
        this.getAllLineItem();
      }
    });
    this.dataSourceFilters.sort = this.sort;
  }

  applyFilter() {
    if (this.filterSearchForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterSearch';
      let filterValue = this.filterSearchForm.controls['descriptionSearch'].value;

      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          this.route = '/getLineItemByGeneralPage';
          this.method = 'POST';
          let data = {
            oilCompany: (this.id == 'construccion' ? false : true),
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            conditionSearch: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {

              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListPartidas = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListPartidas);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  applyFilterDetails() {
    if (this.filterColumForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterColum';
      let typeSearchValue = -1;
      let filterValue = this.filterColumForm.controls['descriptionFilter'].value;

      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          let typeSearch = this.filterColumForm.controls['filterDetails'].value;
          if (typeSearch === 'lineItemGrouping') { typeSearchValue = 0 }
          if (typeSearch === 'description') { typeSearchValue = 1 }
          if (typeSearch === 'reference') { typeSearchValue = 2 }
          if (typeSearch === 'code') { typeSearchValue = 3 }

          this.route = '/getLineItemByConditionPage';
          this.method = 'POST';
          let data = {
            oilCompany: (this.id == 'construccion' ? false : true),
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            typeSearch: typeSearchValue,
            conditionSearch: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {

              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListPartidas = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListPartidas);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  verDetallePartida(row: Partida) {
    this.dialogDetallePartida.open(DetallePartidaComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      // disableClose: true,
      data: { row }
    });
  }

  cleanFilter() {
    this.filterColumForm.get('descriptionFilter')?.setValue('');
    this.filterSearchForm.get('descriptionSearch')?.setValue('');
    if (this.filterColumForm.get('filterDetails')?.value === '0') {
      this.filterColumForm.get('descriptionFilter')?.disable();
      this.disableButtonfilter = true;
      this.filterSearchForm.get('descriptionSearch')?.enable();
      this.disableButtonSearch = false;
      this.paginator.pageIndex = 0;
      this.getAllLineItem();
    } else {
      this.filterColumForm.get('descriptionFilter')?.enable();
      this.disableButtonfilter = false;
      this.filterSearchForm.get('descriptionSearch')?.disable();
      this.disableButtonSearch = true;
    }
  }

  getAllLineItem() {
    this.route = '/getLineItemByDatePage';
    this.method = 'POST';
    this.totalItemsPage = 0;
    this.typeAction = 'filterAll';

    let data = {
      oilCompany: (this.id == 'construccion' ? false : true),
      year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
      month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
      page: (this.paginator ? (this.paginator.pageIndex) : 0),
      pageSize: (this.paginator ? this.paginator.pageSize : 25)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.totalItemsPage = response.data.total;
          this.dataListPartidas = response.data.content;
          this.dataSourceFilters = new MatTableDataSource(this.dataListPartidas);
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      }
    );
  }

  verResumenPartida(row: Partida) {
    this.xpandStatus = false;

    this.route = '/getLineItem';
    this.method = 'POST';
    let data = {
      idLineItem: row.idLineItem
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', false)
      .pipe(takeUntil(this.destroy$)).subscribe(responseItem => {

        if (responseItem.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          //console.log(responseItem);
          this.dataSourceMaterial = responseItem.data.materialDetailList;
          this.dataSourceEquipo = responseItem.data.equipmentDetailList;
          this.dataSourceManosObra = responseItem.data.laborDetailList;

          //Calculo de Totales
          this.totalMateriales = responseItem.data.materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
          this.totalEquipos = responseItem.data.equipmentDetailList.map((t: { equipmentTotalPrice: any; }) => t.equipmentTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
          this.totalManoDeObra = responseItem.data.laborDetailList.map((t: { laborTotalJornal: any; }) => t.laborTotalJornal).reduce((acc: number, value: number) => acc + value, 0);
          this.totalBonoManoDeObra = responseItem.data.laborDetailList.map((t: { laborTotalBonus: any; }) => t.laborTotalBonus).reduce((acc: number, value: number) => acc + value, 0);
          this.apuConditionId = responseItem.data.idApuCondition;

          this.rendimiento = responseItem.data.normalPerformance;
          this.workingHour = 8;

          this.route = '/getApuConditionByIdApu';
          let data = {
            idApuCondition: this.apuConditionId
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', false)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {

              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                //Seteando Porcentajes
                this.porcFinanciamiento = response.data.value.financing;
                this.porcGastosAdministrativos = response.data.value.administrativeExpense;
                this.porcImpuestoIva = response.data.value.iva;
                this.porcOtrosImpuestos = response.data.value.otherTax;
                this.porcUtilidadesImprevisto = response.data.value.unexpectedUtility;
                this.porcPrestacionesManoDeObra = response.data.value.benefit;

                //Calculo Materiales
                this.costoUnicoMateriales = this.totalMateriales;

                //Calculo Costo Unico Equipos
                this.costoUnicoEquipo = this.totalEquipos / this.rendimiento;

                //Calculos Mano de Obra
                this.prestManoDeObra = (this.porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(this.totalManoDeObra, '1.2')?.replace(',', ''));
                this.totalGeneralManoDeObra = this.totalManoDeObra + this.totalBonoManoDeObra + this.prestManoDeObra;
                let totalGeneralManoDeObraTrans = (this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2'))?.replace(',', '');
                this.costoUnicoManoDeObra = Number(totalGeneralManoDeObraTrans) / this.rendimiento;

                let costoUnicoManoDeObraRounded = (this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2'))?.replace(',', '');
                let costoUnicoEquipoRounded = (this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2'))?.replace(',', '');
                let costoUnicoMaterialesRounded = (this.decimalPipe.transform(this.costoUnicoMateriales, '1.2-2'))?.replace(',', '');

                //Calculos Partida
                this.costoDirectoSubTotalA = (Number(costoUnicoMaterialesRounded) + Number(costoUnicoEquipoRounded) + Number(costoUnicoManoDeObraRounded));
                let costoDirectoSubTotalARounded = (this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2'))?.replace(',', '');
                this.gastosGeneralesAdmin = Number(costoDirectoSubTotalARounded) * (this.porcGastosAdministrativos / 100);
              let gastosGeneralesAdminRounded = (this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2'))?.replace(',', '');
              this.subTotalB = Number(costoDirectoSubTotalARounded) + (Number(gastosGeneralesAdminRounded));
                let subTotalBRounded = (this.decimalPipe.transform(this.subTotalB, '1.2-2'))?.replace(',', '');
                this.utilidadesImprevisto = Number(subTotalBRounded) * (this.porcUtilidadesImprevisto / 100);
                this.subTotalC = Number(subTotalBRounded) + this.utilidadesImprevisto;
                this.financiamiento = this.subTotalC * (this.porcFinanciamiento / 100);
                this.precioUnitarioSinImpuesto = this.subTotalC + this.financiamiento;
                this.montoImpuestoIva = this.precioUnitarioSinImpuesto * (this.porcImpuestoIva / 100);
                this.montoOtrosImpuestos = this.precioUnitarioSinImpuesto * (this.porcOtrosImpuestos / 100);
                this.precioUnitario = this.precioUnitarioSinImpuesto + this.montoImpuestoIva + this.montoOtrosImpuestos;

                //Calculo % de incidencias
                this.porcIncidenciasMateriales = (Number(costoUnicoMaterialesRounded) / (Number(costoDirectoSubTotalARounded))) * 100;
                this.porcIncidenciasEquipos = (Number(costoUnicoEquipoRounded) / (Number(costoDirectoSubTotalARounded))) * 100;
                this.porcIncidenciasManoDeObra = (Number(costoUnicoManoDeObraRounded) / (Number(costoDirectoSubTotalARounded))) * 100;

                this.totalTrabajadores = responseItem.data.laborDetailList.map((t: { quantityLabor: any; }) => t.quantityLabor).reduce((acc: number, value: number) => acc + value, 0);
                this.workingHourDay = this.totalTrabajadores * this.workingHour;

              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });

          this.referenciaPartida = row.reference;
          this.descripcionPartida = row.description
          this.xpandDisabled = false;
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          this.apiCallService.hideSpinner();
        }
      });
  }

  resetPaginator(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value.trim();
    if (filterValue == '') {
      this.paginator.pageIndex = 0;
      this.getAllLineItem();
    }
  }

}
